<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>调剂系统</el-breadcrumb-item>
        <el-breadcrumb-item>信息审核</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">信息审核</h2>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">

        <el-form-item label="审核类型">
          <el-select clearable
                     v-model="query.amend_types"
                     placeholder="请选择"
                     @input="fetchList(true)">
            <el-option v-for="item in filter.checkTypes"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="审核状态">
          <el-select clearable
                     v-model="query.statuses"
                     placeholder="请选择"
                     @input="fetchList(true)">
            <el-option v-for="item in filter.checkStatus"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->

      </el-form>
    </div>
    <div class="results card">
      <div class="values-header"
           style="display:flex;  justify-content: space-between;margin-bottom:10px">
        <p class="title">审核列表</p>
        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="query.statuses"
                            @change="fetchList(true)">
              <el-radio-button v-for="(item, index) in filter.checkStatus"
                               :key="index"
                               :label="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <!-- <el-button type="primary"
                   style="height:40px"
                   @click="oneClick()">一键核验</el-button> -->
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           width="70"
                           label="ID"
                           align="center">
          </el-table-column>
          <el-table-column label="提交时间"
                           align="center"
                           width="150"
                           show-overflow-tooltip>

            <template slot-scope="scope">
              {{
                scope.row.create_time
                  ? $moment(scope.row.create_time).format("YYYY-MM-DD hh:mm")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="realname"
                           width="90"
                           label="姓名"
                           align="center">
          </el-table-column>
          <el-table-column prop="amend_type"
                           label="类型"
                           align="center"
                           width="90"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.amend_type==1? '报录审核':'成绩审核'}}
            </template>
          </el-table-column>
          <el-table-column label="报录信息"
                           align="center"
                           width="200">
            <template slot-scope="scope">
              {{
      scope.row.apply_college_name || scope.row.apply_academy_name || 
      scope.row.apply_major_code || scope.row.apply_major_name 
        ? `${scope.row.apply_college_name || '--'}/${scope.row.apply_academy_name || '--'}/${scope.row.apply_major_code || '--'}${scope.row.apply_major_name || '--'}`
        : '--'
    }}
            </template>
          </el-table-column>
          <el-table-column prop="exam_score_total"
                           width="90"
                           label="总分"
                           align="center">
          </el-table-column>
          <el-table-column label="成绩信息"
                           align="center"
                           width="120"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <!-- 判断所有成绩字段是否为空 -->
              <span v-if="!scope.row.exam_score_politics && 
                !scope.row.exam_score_language && 
                !scope.row.exam_score_business_1 && 
                !scope.row.exam_score_business_2">
                --
              </span>
              <span v-else>
                {{ scope.row.exam_score_politics?scope.row.exam_score_politics:'--' }}/{{ scope.row.exam_score_language?scope.row.exam_score_language:'--'}}/{{scope.row.exam_score_business_1?scope.row.exam_score_business_1:'--'}}/{{scope.row.exam_score_business_2?scope.row.exam_score_business_2:'--'}}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="报录截图"
                           align="center">
            <template slot-scope="scope">
              <el-image v-if="scope.row.apply_certify_img"
                        style="width: 60px; height: 60px"
                        :src="scope.row.apply_certify_img"
                        :preview-src-list="[scope.row.apply_certify_img]">
              </el-image>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column label="成绩截图"
                           align="center">
            <template slot-scope="scope">
              <el-image v-if="scope.row.score_certify_img"
                        style="width: 60px; height: 60px"
                        :src="scope.row.score_certify_img"
                        :preview-src-list="[scope.row.score_certify_img]">
              </el-image>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column label="审核状态"
                           align="center"
                           width="150"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateStatus(scope.row.status) }}
            </template>
          </el-table-column>
          <el-table-column label="更新时间"
                           align="center"
                           width="150"
                           show-overflow-tooltip>

            <template slot-scope="scope">
              {{
                scope.row.update_time
                  ? $moment(scope.row.update_time).format("YYYY-MM-DD hh:mm")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="150">
            <template slot-scope="scope">

              <el-link type="primary"
                       :underline="false"
                       @click="handelCheck(scope.row)">审核</el-link>
              <!-- v-if="scope.row.status=='0'" -->
              <!-- @click="handelDelete(scope.row.id)" -->
              <el-link type="danger"
                       @click="handelDelete(scope.row.id)"
                       :underline="false">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <ApplyCheckDialog :visible.sync="dialogVisible"
                      :audit-type="auditType"
                      :data-form="formData"
                      :id_array="idArray"
                      @confirm="handleConfirm"
                      @close="handleClose" />
  </div>

</template>

<script>
import { applyInfoList, applyInfoDate } from '@/api/adjust'
import ApplyCheckDialog from '@/components/dialog/adjust/ApplyCheckDialog.vue'
export default {
  components: {
    ApplyCheckDialog,
  },
  data() {
    return {
      idArray: [],
      dialogVisible: false,
      auditType: '1',
      formData: null,
      imgShow: false,
      picture_url: '',
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        status: '',
        amend_type: '',
        statuses: 0,
        // year: 2025,
        // check_statuses: 0,
      },
      pageTotal: 10,
      results: [],
      filter: {
        checkStatus: [
          {
            label: '全部',
            value: '',
          },
          {
            label: '未审核',
            value: '0',
          },
          {
            label: '驳回',
            value: '2',
          },
          {
            label: '通过',
            value: '1',
          },
        ],
        checkTypes: [
          {
            label: '报录信息',
            value: '1',
          },
          {
            label: '成绩信息',
            value: '2',
          },
        ],
      },
      loading: false,
      adjust_year: '',
    }
  },
  created() {
    // this.getYear()
    this.fetchList()
  },
  methods: {
    handelCheck(item) {
      this.idArray = this.results.map((item) => item.id)
      this.formData = item
      this.dialogVisible = true
    },
    handleConfirm() {
      this.handleClose()
    },
    handleClose() {
      this.dialogVisible = false
      this.fetchList()
    },
    getYear() {
      adjustConfigList().then((res) => {
        this.adjust_year = res.adjust_year
        this.fetchList()
      })
    },
    mouseover(url) {
      this.imgShow = true
      this.picture_url = url
    },
    oneClick() {
      this.imgShow = true
      let cycleId = 0
      const intervalId = setInterval(() => {
        if (cycleId < this.results.length) {
          this.picture_url = this.results[cycleId].picture_url
          let data = {
            id: this.results[cycleId].id,
            check_status: 1,
          }
          rankput(data).then((res) => {})
          cycleId++ // 处理下一条数据
        } else {
          this.$message({
            type: 'success',
            message: '修改成功!',
          })
          clearInterval(intervalId) // 审核完成后清除定时器
          this.imgShow = false // 恢复审核状态
          this.picture_url = ''
          this.fetchList()
        }
      }, 1000)
    },
    mouseout() {
      this.imgShow = false
      this.picture_url = ''
    },
    rank(id, type, state) {
      let data = {
        id: id,
      }
      let text = ''
      if (type == 1) {
        data.check_status = state
        if (state == 1) {
          this.mouseout()
          text = '“未核验”修改为“已核验”'
        } else {
          text = '“已核验”修改为“未核验”'
        }
      } else {
        data.picture_url = null
        text = '删除成绩截图'
      }
      if (type != 2) {
        this.upRankData(data)
        return
      }
      this.$confirm(`此操作将${text}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.upRankData(data)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消修改',
          })
        })
    },
    upRankData(data) {
      rankput(data).then((res) => {
        this.fetchList()
        this.$message({
          type: 'success',
          message: '修改成功!',
        })
      })
    },

    // 客户端列表请求
    fetchList(isReset = false) {
      this.loading = true
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }

      // let data = {}
      // if (this.query.check_statuses == 2) {
      //   data = {
      //     is_picture_url: 1,
      //     check_statuses: 0,
      //   }
      // } else if (this.query.check_statuses === '0') {
      //   data = {
      //     is_picture_url: 0,
      //   }
      // }
      // let yy = {
      //   ...this.query,
      //   ...data,
      // }
      // yy.year = this.adjust_year
      applyInfoList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
        this.loading = false
      })
      // this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()

      this.fetchList()
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    formateStatus(status) {
      if (status == '0') {
        return '待审核'
      } else if (status == '1') {
        return '已通过'
      } else if (status == '2') {
        return '已驳回'
      }
    },
    handelDelete(id) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          applyInfoDate({ ids: [id] }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchList()
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped lang="less">
/deep/.el-link {
  margin: 0 4px;
}
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
  .el-link {
    font-style: 12px;
  }
}
</style>
